var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditDeliveryTerms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 49,
    viewBox: "0 0 45 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.666748,
    width: 45,
    height: 47.5,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_11591_5268",
    transform: "matrix(0.0111111 0 0 0.0105263 0 0.0263158)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_11591_5268",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC9klEQVR4nO3czWoTURgG4E8XuhG3otZ/t4K30IWCeAnegsWFYJucr4yXIW5cCd6GuFBXFaw/JH5vkgqCSxGirkZmErVgfiYzOXPm533hLDNtn775zpx2WhGGYRiGYRiGYRiGYZg2RxFzISa0llQENhqEliaNHTYahJbQLWx9ox1+icMDiUZn1vaOTK6l2E6vTWj8adm2t5HnbIfQOoXuDk97g06uzUZjAr3OkfEf9MFZQusUOnl7+4pah9B6eDO0nbU2O22ydbgZagVu0XhgQXhIngxRjeU9ob9ArcgiNAgtoVvIRiM8HEcHwqNyRoPQwRunbHQcHImjA+EBOaNRrcUDCwgtoVvIRiM8HEcHwqNyRoPQwRunbHQcHImjA+EBOaNRrcUDCwgtoVvIRiM8HEcHwqNyRoPQzV72jncd6h35g9fnufmkEkpETtLmcdGxUzNNot5JcfZQnH2c/j3OV1F7Jt3BdULrupAHF9Omz3/u+w4brWtAdjZY+Pr0r8LsGkeH5kROsjvYFLXx0m+Ww1NCa07kv9h2Yzm2fSG0FkDOjG1jQmtB5GzYbwmtK2x8yUzOg+2ghNYMyA4XJncXNk4xV8F29l6i/ROE1qzIh+ZtVuzkdck7IVeCn9BQLrIaZm5uS7EHm/mRGwdt83924frnxJkteP1P6drt/JCtgbbFyIpPGa7jETs4EKqC7Bm70bdwdn7JuJh3zfHSW792Qds6m/xvOYwkGl0mtNYNubaNtpohp58YvjcGOeptVBM5hbZXDfn100Z+5CInvszQ2GoEskM/53WH/pGTbPWOi9peK5EdRuKGl6S0TP4x1F67mowDvzN5XqL9Y7Jrd0XtZXU2SPPY5N6V0o1rl6ggcpAm1y0Rkf2HyCXF2ZN63F3UPYrXue4uuPGtkviIOHwjsu9Mjthssvc43OS4KCOKexk3vs+cyUWi9igTctS/WujjtD5qz2fj2g9x9iZ9Ip/IUjyTp/BfiNpjUbsv3cGt9CgdxUdDlPA3wV6xpSfCtfAAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDeliveryTerms);
export default __webpack_public_path__ + "static/media/EditDeliveryTerms.4312d83d87bb068fc0fb3c4c9a2e5297.svg";
export { ForwardRef as ReactComponent };